module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xgbUaU/tc-custom/9781035809585.jpg?1705688222913",
      "alt": "This image is the cover for the book Uncertain Ground"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Uncertain Ground\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Business partners Ron and Neil invest in an attractive East African location following their reluctant forced exit from Zimbabwe during the new land reforms and policies that took hold in the country in 2003. Years later, both men find themselves, their clients and their acquaintances drawn into an unavoidable set of circumstances involving national law enforcement, an international investigation agency and high-level criminal activity. Strong bonding relationships and humour, along with lust, killing and survival come together in this gritty and gripping novel set in the city and in the heart of the largest game reserve in Africa.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joseph Croall\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Joseph Croall was born, raised and educated in Glasgow, Scotland, where he began his career as an engineer. His passion for travel began in 1984 when he left his native Scotland to apply his professional skills globally. The attraction he found towards worldly cultures and writing increased whilst working and travelling overseas. He became inspired to commit to the publication of this novel.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0